"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getServiceContextFolderId_1 = require("owa-mail-store/lib/services/utils/getServiceContextFolderId");
var getServiceItemIds_1 = require("owa-mail-store/lib/services/utils/getServiceItemIds");
var copyItemRequest_1 = require("owa-service/lib/factory/copyItemRequest");
var copyItemOperation_1 = require("owa-service/lib/operation/copyItemOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
/**
 * The service command to copy items to a specified destination folder
 * @param itemIds the ids of the items to be copied
 * @param destinationFolderId the id of destination folder to copy to
 * @return a Promise which contains the CopyItemResponse
 */
function copyItemsService(itemIds, destinationFolderId) {
    var requestBody = configureRequestBody(itemIds, destinationFolderId);
    return copyItemOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = copyItemsService;
/**
 * Configure the CopyItemRequest body
 * @param itemIds the ids of the items to be copied
 * @param destinationFolderId the id of destination folder to copy to
 * @return the CopyItemRequest body
 */
function configureRequestBody(itemIds, destinationFolderId) {
    return copyItemRequest_1.default({
        ToFolderId: getServiceContextFolderId_1.default(destinationFolderId),
        ItemIds: getServiceItemIds_1.default(itemIds),
        ReturnNewItemIds: true,
    });
}
//# sourceMappingURL=copyItemsService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/copyItemsService.js
// module id = 5594
// module chunks = 62